module.exports = __webpack_public_path__ + "img/product-invalid.4d48623f.svg";